<template>
  <section
    id="admin-add-list"
    :dir="$functions.currentLangDirection()"
  >
    <b-card class="admin-page-mobile">
      <b-card-body style="padding: 5%;display: block;background: #fff;">
        <validation-observer ref="Validation">
          <b-form @submit.prevent>
            <b-row>

              <!-- title -->
              <b-col class="col-12 col-md-12">
                <b-form-group
                  label="imei"
                  label-for="vi-imei"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="IMEI"
                    rules="required"
                  >
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="UserIcon" />
                      </b-input-group-prepend>
                      <b-form-textarea
                        id="vi-imei"
                        v-model="device.imei"
                        placeholder=""
                        :state="errors.length > 0 ? false:null"
                        required
                        rows="5"
                      />
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <div
                  class="alert alert-danger"
                  style="padding: 10px;"
                >
                  لطفاً در هر خط یک مورد وارد کنید.
                </div>
              </b-col>

              <!-- پروتکل -->
              <b-col class="col-12 col-md-6">
                <b-form-group
                  label="مدل"
                  label-for="vi-protocol"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="مدل"
                    rules="required"
                  >
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="UserIcon" />
                      </b-input-group-prepend>
                      <b-form-select
                        v-model="device.modelId"
                        :state="errors.length > 0 ? false:null"
                        required
                      >
                        <option
                          selected
                          disabled
                          value=""
                        >
                          انتخاب کنید
                        </option>
                        <option
                          v-for="item in options"
                          :value="item._id"
                        >
                          {{ item.title }} - {{ item.protocol }}
                        </option>
                      </b-form-select>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- port -->
              <b-col class="col-12 col-md-6">
                <b-form-group
                  label="نمایندگی"
                  label-for="vi-port"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="نمایندگی"
                    rules="required"
                  >
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <feather-icon icon="UserIcon" />
                      </b-input-group-prepend>
                      <b-form-select
                        v-model="device.resellerId"
                        required
                        :state="errors.length > 0 ? false:null"
                      >
                        <option
                          selected
                          disabled
                          value=""
                        >
                          انتخاب کنید
                        </option>
                        <option
                          v-for="item in agentList"
                          :value="item._id"
                        >
                          {{ item.name }} {{ item.family }}
                        </option>
                      </b-form-select>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- port -->
              <b-col class="col-12 col-md-6">
                <b-form-group
                  label="سرور"
                  label-for="vi-server"
                >
                  <b-input-group class="input-group-merge">
                    <b-input-group-prepend is-text>
                      <feather-icon icon="UserIcon" />
                    </b-input-group-prepend>
                    <b-form-select
                      v-model="device.serverId"
                      required
                    >
                      <option
                        selected
                        disabled
                        value=""
                      >
                        انتخاب کنید
                      </option>
                      <option
                        v-for="item in serverList"
                        :value="item._id"
                      >
                        {{ item.title }}
                      </option>
                    </b-form-select>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col class="col-12 col-md-6">
                <b-form-group
                  label="اشتراک"
                  label-for="vi-server"
                >
                  <b-input-group class="input-group-merge">
                    <b-input-group-prepend is-text>
                      <feather-icon icon="UserIcon" />
                    </b-input-group-prepend>
                    <b-form-select
                      v-model="device.plan"
                      required
                    >
                      <option
                        selected
                        disabled
                        value=""
                      >
                        انتخاب کنید
                      </option>
                      <option
                        v-for="item in devicePlan"
                        :value="item.value"
                      >
                        {{ item.title }}
                      </option>
                    </b-form-select>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <!-- disabled -->
              <b-col class="col-12 col-md-12">
                <b-form-group>
                  <b-form-checkbox
                    id="disabled"
                    v-model="device.disabled"
                    name="disabled"
                    value="true"
                  >
                    غیرفعال
                  </b-form-checkbox>
                </b-form-group>
              </b-col>

              <!-- reset and submit -->
              <b-col cols="12">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="mr-1"
                  @click="submitForm()"
                >
                  ذخیره
                </b-button>
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  type="reset"
                  class="mr-1"
                  variant="outline-secondary"
                >
                  از نو
                </b-button>
                <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  type="button"
                  class="mr-1"
                  variant="outline-primary"
                  @click.prevent="onCancel"
                >
                  لغو
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-card-body>
    </b-card>
  </section>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BInputGroup, BInputGroupPrepend, BFormCheckbox, BFormSelect, BCard, BCardBody, BFormTextarea,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
// eslint-disable-next-line import/extensions
import ToastificationContent from '@core/components/toastification/ToastificationContent'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

import ModelService from '@/services/model.service'
import DeviceService from '@/services/device.service'
import ServerService from '@/services/server.service'
import router from '@/router'
import Model from '@/models/model'
import Device from '@/models/device'
import customerService from '@/services/customer.service'

export default {
  components: {
    BCardCode,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BFormCheckbox,
    BFormSelect,
    BFormTextarea,
    BCard,
    BCardBody,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      model: new Model('', '', '', ''),
      device: new Device('', '', '', '', '', '', '', '', '', '', '', '', ''),
      options: [],
      agentList: [],
      serverList: [],
      devicePlan: [{ value: 1, title: 'یک ماهه' }, { value: 6, title: 'شش ماهه' }, { value: 12, title: 'یک ساله' }, { value: 24, title: '2 ساله' }, { value: 36, title: '3 ساله' }, { value: 60, title: 'پنج ساله' }],
      required,
    }
  },
  async mounted() {
    try {
      ModelService.getList().then(
        res => {
          if (res.status === 'success') {
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              this.options = res.result.data
            }
          }
        },
      )
    } catch (err) {
      // console.log(err)
    }
    try {
      this.agentList = []
      await customerService.getAll({ type: 1 }).then(
        res => {
          if (res.status === 'success') {
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              for (let i = 0; i <= res.result.data.length - 1; i += 1) {
                this.agentList.push(res.result.data[i])
              }
            }
          }
        },
      )
      await customerService.getAll({ type: 2 }).then(
        res => {
          if (res.status === 'success') {
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              for (let i = 0; i <= res.result.data.length - 1; i += 1) {
                this.agentList.push(res.result.data[i])
              }
            }
          }
        },
      )
      // console.log(this.agentList)
    } catch (err) {
      // console.log(err)
    }
    try {
      ServerService.getList().then(
        res => {
          if (res.status === 'success') {
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              this.serverList = res.result.data
            } else {
              this.serverList = []
            }
          }
        },
      )
    } catch (err) {
      // console.log(err)
    }
  },
  methods: {
    async submitForm() {
      this.locale = 'fa'
      this.$refs.Validation.validate().then(success => {
        if (success) {
          this.device.disabled = this.disabled === 'true'
          DeviceService.add(this.device)
            .then(
              res => {
                if (res.status === 'success') {
                  router.push({ name: 'admin-device-all' })
                } else {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'add device error',
                      text: res.message,
                      icon: 'XIcon',
                      variant: 'danger',
                    },
                  })
                }
              },
              error => {
                this.message = (error.response && error.response.data)
                        || error.message
                        || error.toString()
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'register error',
                    text: this.message,
                    icon: 'XIcon',
                    variant: 'danger',
                  },
                })
              },
            )
        }
      })
    },
    onCancel() {
      this.show = false
      this.$router.push({ name: 'admin-device-all' })
    },
  },
}
</script>
